<template>
    <v-dialog
        v-model="deleteBillingCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">            
            <v-icon
                v-if="modelType==='Delete'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                delete
            </v-icon>
        </template>
        <v-card id="delete_member_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mt-5">
                    Are you sure you want to delete <b>Billing Code : {{ code }}</b> from the Response ?                   
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="deleteBillingCode(rowid)"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        modelType: {
            type: String,
            required: true
        },
        responseData: {
            type: [Object],
            default: () => {},
            required: true,
        },      
    },
    data() {
        const { TR_rowid, rowid = '',code = '', amount = '', minutes = '' } = this.responseData;
        return {
            deleteBillingCodeDialog: false,
            TR_rowid,
            rowid,
            code,
            amount,
            minutes,
        };
    },
    methods: {
        closedDialog() {
            this.deleteBillingCodeDialog = false;
        },
        openDialog() {
            this.deleteBillingCodeDialog = true;
        },
        async deleteBillingCode(rowid) { 
            let data = {
                TRB_rowid: rowid
            };           
            let response = await webtmsBackend.deleteResponseBilling(data);
            if(response.result.result === 'ERR') {
                this.$store.dispatch('setSnackbar', { color:'error', text: response.result.message });
            }else if(response.result.result === 'OK') {
                this.$store.dispatch('updateTicketResponsesBilling', response.Ticket_ResponsesBilling);           
                this.$store.dispatch('setSnackbar', { text: response.result.message, color:'success' });
            }
            this.closedDialog();
        }
    }
};
</script>
<style>
</style>
